var map = {
	"./icn-agenda.svg": 1707,
	"./icn-automotive.svg": 1708,
	"./icn-b2b.svg": 1709,
	"./icn-claimWizard-white.svg": 1710,
	"./icn-claims.svg": 1711,
	"./icn-clients.svg": 1712,
	"./icn-contracts.svg": 1713,
	"./icn-credit.svg": 1714,
	"./icn-dsdocuments-blue.svg": 1715,
	"./icn-dsdocuments-green.svg": 1716,
	"./icn-dsdocuments-white.svg": 1717,
	"./icn-dsdocuments.svg": 1718,
	"./icn-family.svg": 1719,
	"./icn-faq.svg": 1720,
	"./icn-fire.svg": 1721,
	"./icn-generali.svg": 1722,
	"./icn-health.svg": 1723,
	"./icn-home.svg": 1724,
	"./icn-inbox-blue.svg": 1725,
	"./icn-inbox-white.svg": 1726,
	"./icn-inbox.svg": 1727,
	"./icn-info.svg": 1728,
	"./icn-life.svg": 1729,
	"./icn-link_1x_blue.svg": 1730,
	"./icn-links.svg": 1731,
	"./icn-logout.svg": 1732,
	"./icn-misc.svg": 1733,
	"./icn-news.svg": 1734,
	"./icn-no-result.svg": 204,
	"./icn-office.svg": 1735,
	"./icn-outbox.svg": 1736,
	"./icn-outline-location_on-24px.svg": 1737,
	"./icn-production.svg": 1738,
	"./icn-tasklist.svg": 1739,
	"./icn-transport.svg": 1740,
	"./icn-webapps.svg": 1741,
	"./icn-willdoc.svg": 1742,
	"./icn-workinjuries.svg": 1743
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1753;



//////////////////
// WEBPACK FOOTER
// ./resources/images ^\.\/icn\-.*\.svg$
// module id = 1753
// module chunks = 0